import urls from './restConstants';
import api from './restApi';

const documentsCollection = api.all(urls.documents);

export default documentsCollection;



// WEBPACK FOOTER //
// ./book/src/commons/rest/documentsRest.js